import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button';
import { format } from 'translations';
import { lazyImageAttributes } from 'util/react/image-attributes';
import normaliseTrailingSlash from 'util/misc/normalise-trailing-slash';
import LazyImage from 'components/lazy-image';

export default function ArticleShort({ title, text, link, image }) {
    return (
        <article className="cms-article-short">
            <div className="cms-article-short--row grid--row">
                <div className="cms-article-short--col grid--col">
                    <figure className="cms-article-short--figure">
                        <LazyImage>
                            <img className="cms-article-short--image" { ...lazyImageAttributes(image) } />
                        </LazyImage>
                    </figure>
                </div>
                <div className="cms-article-short--col grid--col">
                    <h1 className="cms-article-short--title">{ title }</h1>
                    <div className="cms-article-short--text" dangerouslySetInnerHTML={ { __html: format(text) } }/>
                    { link && (
                        <div className="cms-article-short--button">
                            <Button tag="a" to={ normaliseTrailingSlash(link.to) } facet="primary" size="small">
                                { link.text }
                            </Button>
                        </div>
                    ) }
                </div>
            </div>
        </article>
    );
}

ArticleShort.propTypes = {
    image: PropTypes.shape({
        src: PropTypes.object.isRequired,
        title: PropTypes.string,
        alt: PropTypes.string,
    }),
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    link: PropTypes.shape({
        to: PropTypes.string,
        text: PropTypes.string,
    }),
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/article-short/index.js